'use client'
import React, { useState, useEffect, useRef } from 'react'
// import { useSession } from 'next-auth/react'
import Image from 'next/image'
import LinkComponent from './LinkComponent'
import { AiOutlineLayout, AiFillHeart, AiOutlineHeart } from "react-icons/ai"
import { BiArea, BiSolidArea } from "react-icons/bi";
import { FaBed, FaBath } from "react-icons/fa"
import { FaMountain } from "react-icons/fa";
import { MdBeachAccess, MdPlaylistAddCheckCircle } from "react-icons/md";
import { FaWater } from "react-icons/fa";
import { IoMdVideocam } from 'react-icons/io'
import tailwindConfig from '@tailwind.config'
import CurrencySymbol from '@components/CurrencySymbol'
import { sendGAEvent } from '@next/third-parties/google'

function GallerySlider({ images, alt, blur }) {
    const [index, setIndex] = useState(0)
    const [hovered, setHovered] = useState(false)
    const touchStart = useRef(null)
    const total = images?.length ?? 0
    if (!total) return null
    const prev = (e) => { e.preventDefault(); e.stopPropagation(); setIndex(i => (i - 1 + total) % total) }
    const next = (e) => { e.preventDefault(); e.stopPropagation(); setIndex(i => (i + 1) % total) }
    const onTouchStart = (e) => { touchStart.current = e.touches[0].clientX }
    const onTouchEnd = (e) => {
        if (touchStart.current === null) return
        const delta = touchStart.current - e.changedTouches[0].clientX
        if (Math.abs(delta) > 40) delta > 0 ? setIndex(i => (i + 1) % total) : setIndex(i => (i - 1 + total) % total)
        touchStart.current = null
    }
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
            {images.map((src, i) => (
                <div key={i} style={{ position: 'absolute', inset: 0, opacity: i === index ? 1 : 0, transition: 'opacity 0.3s ease', pointerEvents: i === index ? 'auto' : 'none' }}>
                    <Image placeholder={i === 0 && blur ? 'blur' : 'empty'} blurDataURL={i === 0 ? blur : undefined} src={src || '/images/imageplaceholder.jpeg'} fill alt={`${alt} ${i + 1}`} style={{ objectFit: 'cover' }} />
                </div>
            ))}
            {total > 1 && (
                <>
                    <button onClick={prev} style={{ position: 'absolute', insetInlineStart: 8, top: '50%', transform: 'translateY(-50%)', zIndex: 4, background: 'rgba(0,0,0,0.35)', border: 'none', borderRadius: 6, width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#fff', backdropFilter: 'blur(4px)', padding: 0, opacity: 1, transition: 'opacity 0.2s ease' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
                    </button>
                    <button onClick={next} style={{ position: 'absolute', insetInlineEnd: 8, top: '50%', transform: 'translateY(-50%)', zIndex: 4, background: 'rgba(0,0,0,0.35)', border: 'none', borderRadius: 6, width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#fff', backdropFilter: 'blur(4px)', padding: 0, opacity: 1, transition: 'opacity 0.2s ease' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                    </button>
                    <div style={{ position: 'absolute', bottom: 8, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 5, zIndex: 4, opacity: hovered ? 1 : 0, transition: 'opacity 0.2s ease' }}>
                        {images.map((_, i) => <button key={i} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIndex(i) }} style={{ width: i === index ? 16 : 6, height: 6, borderRadius: 3, border: 'none', padding: 0, cursor: 'pointer', background: i === index ? '#fff' : 'rgba(255,255,255,0.5)', transition: 'all 0.2s ease' }} />)}
                    </div>
                    <div style={{ position: 'absolute', top: 8, insetInlineStart: 8, zIndex: 4, background: 'rgba(0,0,0,0.4)', color: '#fff', fontSize: '0.65rem', fontWeight: 600, padding: '2px 7px', borderRadius: 20, backdropFilter: 'blur(4px)', letterSpacing: '0.04em', opacity: hovered ? 1 : 0, transition: 'opacity 0.2s ease' }}>
                        {index + 1} / {total}
                    </div>
                </>
            )}
        </div>
    )
}

const NewDevelopmentCard = ({ project, imageWidth = 400, imageHeight = 300, dictionary, lang }) => {
    // const [showLikeBtn, setShowLikeBtn] = useState(false)
    // const [isLiked, setIsLiked] = useState(property.isLiked)
    // const { data: session } = useSession()

    // const handleLike = async () => {
    //     const isLike = await sendLike(property.id, session?.user?.email)
    //     setIsLiked((prevLike) => !prevLike)
    //     property.isLiked = !property.isLiked
    // };


    // useEffect(() => {
    //     if (session && session.user !== null) {
    //         setShowLikeBtn(true)
    //     }
    // }, [])

    const galleryImages = (project.gallery && project.gallery.length > 0)
        ? project.gallery
        : [project.cover]

    return (
        <div 
            className='relative w-full m-1 rounded-lg shadow-md hover:shadow-sm hover:shadow-maincolor'
            onClick={() => sendGAEvent({ 
                event: "select_project",
                pproject_id: project.id,
                project_name: project.name,
                project_type: 'new_development',
                project_location: project.districts[0]?.subdistrictName?.['en'],
            })} 
        >
            <LinkComponent
                className='w-full'
                href={'/new-developments/' + project.slug}
            >
                <div className='relative w-full aspect-[4/3] rounded-t-md overflow-hidden'>
                    {/* {(showLikeBtn == true && isLiked == false) && (
                        <div title="Left-click on this icon to save this property" onClick={handleLike} className='absolute flex flex-row flex-wrap top-1 right-1 z-40 h-8 w-8 justify-center items-center border-[1px] border-secondary rounded-md p-1'>
                            <AiOutlineHeart
                                size={24}
                                color={tailwindConfig.theme.extend.colors.secondary}
                            />
                        </div>
                    )} */}
                    {/* {(showLikeBtn == true && isLiked == true) && (
                        <div title="Left-click to unlike this property" onClick={handleLike} className='absolute flex flex-row flex-wrap top-1 right-1 z-40 h-8 w-8 justify-center items-center border-[1px] border-third rounded-md p-1'>
                            <AiFillHeart
                                size={24}
                                color={tailwindConfig.theme.extend.colors.third}
                            />
                        </div>
                    )} */}
                    <GallerySlider
                        images={galleryImages}
                        alt={project.slug}
                        blur={project.blur}
                    />
                        {(project?.videoUrl) ? (
                            <div className='absolute w-full bottom-1 left-1 flex flex-row flex-wrap z-10 pointer-events-none'>
                                {project.videoUrl ? (
                                    <div className={`rounded-md p-1 text-light bg-red-800 text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                                ) : null}
                            </div>
                        ) : null}
                        {/* {(project?.promotionTitle?.[lang]) ? (
                            <div className='absolute w-full top-1 left-1 flex flex-row flex-wrap'>
                                <div className={`rounded-md p-1 bg-third text-light border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><span className='ml-1'>{project.promotionTitle}</span></div>
                            </div>
                        ) : null} */}
                </div>

                <div className='p-2'>
                    {/* <div className='text-maincolor text-xl font-semibold rounded-r-md z-10'><h3>{property.category} for {property.saleType !== 'salerent' ? property.saleType : 'Sale and Rent'}</h3></div> */}
                    <div className='text-maincolor text-xl font-semibold rounded-r-md z-10 h-[60px]'><span className='line-clamp-2'>{project.name}</span></div>
                    {project.startingPrice && (
                        <p className='text-secondary text-xl'>{dictionary.fromPriceFront}{project.startingPrice}{dictionary.fromPriceAfter}</p>
                    )}
                    <div className='w-full border-b-[1px] border-forth pb-1 mb-1'>
                        <p className='text-secondary text-xl'>{project.districts[0]?.subdistrictName?.[lang] ? project?.districts[0]?.subdistrictName?.[lang] : project.districts?.[0]?.subdistrict}</p>
                    </div>
                    {/* <div className='flex flex-row w-full justify-between'>
                        <div className='flex flex-row items-center w-full'>
                            <BiArea
                                color={tailwindConfig.theme.extend.colors.secondary}
                            />
                            <span className='ml-2 text-xl text-maincolor'>{project.layouts.length} {dictionary.availableLayouts}</span>
                        </div>
                    </div> */}
                </div>
            </LinkComponent >
        </div>
    )
}

export default NewDevelopmentCard